<template>
	<div id="stockInfoNew" :class="{'disabled': fetchingProduct}">
		<buy-again-message
			v-if="buyAgainData && !buyAgainData.inStockForFulfillmentType"
			:message-first-line="buyAgainData.messageFirstLine"
			:message-second-line="buyAgainData.messageSecondLine"
		/>
		<div v-if="!showSpecialMessageBox" class="stock-info-container-new" :style="ctaStyles">
			<quantity-exception-messages
				@showChangeStore="showChangeStore = true"
			/>
			<div class="flex flex-between equal-height" v-if="!hideCTA">
				<quantity-field
					class="stock-info-quantity-field"
					:min="minBuyableQty"
					:increment-disabled="this.productHasFulfillmentError
						|| !this.productHasStock"
					:interval="product.qtyInterval ? product.qtyInterval : 1"
					v-model="quantity"
					:disabled="!productHasStock || loading"
					style="margin-right: 10px"
					:highlighted="isQuantityFieldHighlighted"
				/>
				<product-call-to-action
					class="flex-grow"
					:loading="loading"
					@addToCart="$emit('add-to-cart')"
				/>
			</div>

			<fulfillment-options :loading="loading" />

			<div v-if="product.pdpCustomText" class="custom-text">
				<div>
					<strong>Note: </strong>
					{{ product.pdpCustomText }}
				</div>
			</div>
		</div>
		<!--Side Menus-->
		<change-store-side-menu
			:show="showChangeStore"
			@close="showChangeStore = false"
			:current-zip="currentZip"
			@store-changed="handleStoreChanged"
			:blain-number="product.blainNumber"
		/>
	</div>
</template>

<script>
import BuyAgainMessage from './callouts/BuyAgainMessage.vue';
import ChangeStoreSideMenu from 'JS/components/side-menus/change-store/ChangeStoreSideMenu.vue';
import FulfillmentOptions from './fulfillment/FulfillmentOptions.vue';
import ProductCallToAction from './ProductCallToAction.vue';
import QuantityExceptionMessages from './QuantityExceptionMessages.vue';
import QuantityField from '../../components/QuantityField.vue';

export default {
	name: 'ProductStockInfo',
	components: {
		FulfillmentOptions,
		QuantityField,
		ProductCallToAction,
		ChangeStoreSideMenu,
		BuyAgainMessage,
		QuantityExceptionMessages
	},
	computed: {
		childSelectors() {
			return this.$store.state.childSelectors;
		},
		fetchingProduct() {
			return this.$store.state.fetchingProduct;
		},
		product() {
			return this.$store.state.product;
		},
		minBuyableQty() {
			return this.$store.getters.minBuyableQty;
		},
		quantityExceedsStock() {
			return this.$store.getters.quantityExceedsStock;
		},
		remainingSelectors() {
			return this.$store.getters.remainingSelectors;
		},
		productHasStock() {
			return this.$store.getters.productHasStock;
		},
		currentZip() {
			return this.$store.state.currentZip;
		},
		productHasFulfillmentError() {
			return this.$store.getters.productHasFulfillmentError;
		},
		isQuantityFieldHighlighted() {
			return !this.productHasFulfillmentError
				&& this.productHasStock
				&& this.quantityExceedsStock
				&& this.remainingSelectors.length == 0;
		},
		buyAgainData() {
			return this.$store.state.buyAgainData;
		},
		loading() {
			return this.$store.state.addingToCart;
		},
		quantity: {
			get() {
				return this.$store.state.quantity;
			},
			set(val) {
				this.$store.commit('quantity',  val );
			}
		},

		isMobile() {
			return this.$mq === 'pdp-mobile';
		},
		showSpecialMessageBox() {
			return this.$store.getters.showSpecialMessageBox;
		},
		ctaStyles() {
			return this.childSelectors.length > 0 || this.isMobile ? 'border-top: 1px solid #CCCCCC;' : 'border-top: none;';
		},
		hideCTA() {
			return this.showTopLevelBackInStockForm
			|| (this.$store.getters.isShippingDisabled
					&& this.$store.getters.isPickupDisabled
					&& this.$store.getters.isDeliveryDisabled);
		},
		showTopLevelBackInStockForm() {
			return this.$store.getters.showTopLevelBackInStockForm;
		},
	},
	methods: {
		handleStoreChanged() {
			if (typeof window !== 'undefined') {
				const url = `${window.location.origin}${window.location.pathname}?fulfillment_type=${this.fulfillmentType}`;
				window.history.replaceState({}, document.title, url);
				window.location.reload();
			}
		}
	},
	data() {
		return {
			showChangeStore: false,
		};
	}
};
</script>

<style lang="less" scoped>
@import '../../../less/_mixins.less';

#stockInfoNew {
	&.disabled {
		opacity: 0.8;
		pointer-events: none;
	}
}

.stock-info-container-new {
	padding: 10px 0px;

	.stock-info-quantity-field {
		/deep/ .quantity-field-wrapper {
			height: 100%;
		}
	}


	.custom-text {
		font-size: 14px;
		line-height: 1.5em;
		padding: 10px 5px;
		> div {
			border-left: 3px solid @red;
			padding-left: 15px;
		}

		strong {
			color: @red;
		}

	}


	.mobile-styles({
		.custom-text  {
			font-size: 12px;
		}
	});
}
</style>